import { render } from "./FaqsView.vue?vue&type=template&id=0950dec1"
import script from "./FaqsView.vue?vue&type=script&lang=js"
export * from "./FaqsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__